import { render, staticRenderFns } from "./translate-group.vue?vue&type=template&id=6ea5635a"
import script from "./translate-group.ts?vue&type=script&lang=js&external"
export * from "./translate-group.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports